import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { useChat } from '../../../Hooks/UseChat'

import './HeaderChatMenu.scss'

const HeaderChatAction = () => {

  const location = useLocation().pathname

  const { enabled: chatsEnabled, newChats, currentChat } = useChat()

  if (!chatsEnabled) return null

  return (
    <Link className="link-to-chat" to={`/chat${currentChat ? '/' + currentChat._id : ''}`}>
      <div className={`right-dropdown svg-icon-menu cursor-pointer ${location === '/chat' ? 'active' : ''}`}>
        <div className="svg-icon-container">
          {newChats > 0 && (
            <span className="new-chats-badge badge badge-primary">
              {newChats}
            </span>
          )}

          <i className="far fa-comment-alt"></i>
        </div>
      </div>
    </Link>
  )
}

export default HeaderChatAction
